import { render, staticRenderFns } from "./DisputeResolutionTask.vue?vue&type=template&id=93edfd36&scoped=true&"
import script from "./DisputeResolutionTask.vue?vue&type=script&lang=js&"
export * from "./DisputeResolutionTask.vue?vue&type=script&lang=js&"
import style0 from "./DisputeResolutionTask.vue?vue&type=style&index=0&id=93edfd36&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "93edfd36",
  null
  
)

export default component.exports